<template>
	<div class="view" :style="{animation: !$loaded ? 'bottomElation 0.5s 1s both' : 'bottomElation 0.5s both'}">
		<img class="preview-image" :src="home" alt="home">
		<div class="description">
			Jesteśmy firmą remontowo-budowlaną, działamy na terenie województwa pomorskiego.
			Od ponad 13 lat pomagamy spełniać <span class="naj"><strong>Na-J</strong></span>większe marzenia o własnym domu.
			Dostosowujemy nasze usługi do potrzeb każdego inwestora.
			Realizujemy budowy domów jednorodzinnych i wielorodzinnych od organizacji nadzoru budowlanego i placu budowy poprzez wznoszenie fundamentów, murów, stropów, aż po dach.
			Wykonujemy też docieplenia, elewacje, remonty; budujemy ogrodzenia i mury oporowe.
			W całym procesie doradzamy i wspieramy swoją wiedzą i doświadczeniem.
			Każdą inwestycję wykonujemy z <span class="naj"><strong>Na-J</strong></span>wyższą starannością oraz pełnym zaangażowaniem.
			Działamy zgodnie z zasadami sztuki budowlanej, korzystając ze sprawdzonych metod i materiałów, dzięki czemu mamy pewność, że jakość naszych usług sprosta <span class="naj"><strong>Na-J</strong></span>wyższym oczekiwaniom nawet <span class="naj"><strong>Na-J</strong></span>bardziej wymagającego klienta.
		</div>
		<div class="site-preview">
			<div class="site-image" v-bg="offer" />
			<div class="site-ad">
				<h3 class="site-title">Oferta</h3>
				<p class="site-description">
					Jako firma z 13-letnim doświadczeniem, jesteśmy zdolni do wykonania <span class="naj"><strong>Na-J</strong>różniejszych</span> zleceń. Przekonaj się o tym sprawdzając naszą ofertę.
				</p>
				<router-link to="/oferta" class="site-link">Sprawdź</router-link>
			</div>
		</div>
		<div class="site-preview">
			<div class="site-image" v-bg="realizations" />
			<div class="site-ad">
				<h3 class="site-title">Realizacje</h3>
				<p class="site-description">
					Opinie klientów oraz efekty naszej pracy są <span class="naj"><strong>Na-J</strong>lepszym</span> dowodem na jakość naszych usług.
					Zobacz nasze realizacje i przekonaj się sam.
				</p>
				<router-link to="/realizacje" class="site-link">Sprawdź</router-link>
			</div>
		</div>
		<div class="site-preview">
			<div class="site-image" v-bg="contact" />
			<div class="site-ad">
				<h3 class="site-title">Kontakt</h3>
				<p class="site-description">
					Zainteresowany? A może potrzebujesz więcej informacji? Zapraszamy do kontaktu. Nie czekaj, już dziś dołącz do grona <span class="naj"><strong>Na-J</strong>szczęśliwszych</span> klientów!
				</p>
				<router-link to="/kontakt" class="site-link">Sprawdź</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import home from '@/Assets/Images/home/home.jpg'
import offer from '@/Assets/Images/home/offer.jpg'
import realizations from '@/Assets/Images/home/realizations.jpg'
import contact from '@/Assets/Images/home/contact.jpg'
export default {
	name: 'Home',
	data() {
		return {
			home,
			offer,
			realizations,
			contact
		}
	}
}
</script>

<style lang="scss" scoped>
	.preview-image {
		width: 700px;
		height: 400px;
		max-width: 100%;
		max-height: calc((100vw - 40px) * 0.57);
		object-fit: contain;
		border-radius: 20px;
	}
	.description {
		font-size: 20px;
		margin-bottom: 100px;
	}
	.site-preview {
		width: 100%;
		max-width: 1300px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		margin: 50px auto;
		flex-wrap: wrap;
		&:nth-child(even) {
			flex-direction: row-reverse;
		}
		&:last-child {
			margin-bottom: 0;
		}
		.site-image {
			width: 550px;
			max-width: 100%;
			height: 350px;
			background: no-repeat center center;
			background-size: cover;
			border-radius: 20px;
		}
		.site-ad {
			margin: 50px 30px;
			width: 450px;
			.site-title {
				font-size: 30px;
				margin: 0;
				@include line;
			}
			.site-description {
				font-size: 19px;
				margin: 20px 0;
			}
			.site-link {
				position: relative;
				width: 130px;
				display: block;
				margin: 0 auto;
				padding: 5px;
				border: 3px solid $primary;
				color: $primary;
				border-radius: 30px;
				text-transform: uppercase;
				text-decoration: none;
				font-weight: bold;
				letter-spacing: 1px;
				transition: 0.3s ease;
				@include hover {
					background-color: $primary;
					color: $bg;
				}
			}
		}
	}
</style>
